<template>
  <div class="relative">
    <hero :heading="heading" />
    <app-section>
      <project-list :projects="projects" :showAttr="true" :blink="blinkAttr" />
    </app-section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppSection from "../components/Common/Section";
import Hero from "../components/Common/Hero";
import ProjectList from "../components/Project/List";

/**
 * @name Work View
 * @description work index where users can see all my projects in a single list
 */
export default {
  components: {
    AppSection,
    Hero,
    ProjectList
  },
  data: () => ({
    heading: "Most of the projects I've worked on over the years"
  }),
  computed: {
    ...mapGetters("work", ["projects"]),
    blinkAttr() {
      return this.$route.hash ? true : false;
    }
  }
};
</script>
